module["exports"] = [
  "/4###########L/",
  "/4###-####-####-###L/"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/credit_card/visa.js
// module id = 1279
// module chunks = 1